// extracted by mini-css-extract-plugin
export default {"animateVertical":"upload-icon-module__animateVertical--kR37r","verticalMove":"upload-icon-module__verticalMove--MycMs","noAnimation":"upload-icon-module__noAnimation--sLBZP"};